// removed by extract-text-webpack-plugin
module.exports = {"buttons":"_3b1iEGbE86V7Sd2ZrE7xyM","loginTerms":"_1cjCWAqO5HVeAZQRit7DVm","forgotTerms":"G8CTNXvIC3kDDGsfW_HW0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AuthForms/AuthForm.scss
// module id = 622
// module chunks = 1